import React, { useState, useEffect } from "react";
import profileIcon from "../bank-css/icons/farmer-pic1.jpg";
import { apiRequest } from "../../services/api-request";
import "./index.css";

const AnimalDetails = () => {
  // const { user = {} } = useAppContext();
  // const { userType } = useParams();
    const [fields, setFields] = useState({animal_details:{}});
    const [ownerFields, setOwnerFields] = useState({});
    const [animalid, setAnimalID] = useState('');

    useEffect(() => {
        let url = window.location.href;
        let animal_id = url.substring(url.lastIndexOf('/') + 1);
        setAnimalID(animal_id)
        apiRequest({
            url: `bank/animal-details/${animal_id}`,
            method: "GET",
        })
        .then((res) => {
            setFields({animal_details: res.data.animal_data});

            let propic = res.data.animal_data.user_details.pro_pic.replace('https://dev-animal-images.anitra.co.in/','');
            if(propic === ''){
                res.data.animal_data.user_details.pro_pic = ''
            }
            setOwnerFields(res.data.animal_data.user_details);
        })
        .catch((err) => {
            console.log(err)
        });
    }, []);

  return (
    <div>
        <div className="applicant-report-header">
            <h1 className="applicant-report-title">Animal Details</h1>
        </div>

        <div className="report-section">
            <div className="report-section-header">OWNER DETAILS</div>
            <div className="report-section-content">
                <div className="applicant-info">
                    <div className="info-row">
                        <div className="info-label">Name:</div>
                        <div className="info-value">{ownerFields?.farmer_data?.name}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-label">Contact Number:</div>
                        <div className="info-value">{ownerFields?.farmer_data?.mobile}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-label">Address:</div>
                        <div className="info-value">{ownerFields?.farmer_data?.village_name}, {ownerFields?.farmer_data?.mandal_name}, {ownerFields?.farmer_data?.district_name}, {ownerFields?.farmer_data?.state_name}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-label">Loan Officer Name:</div>
                        <div className="info-value">{ownerFields?.loan_officer_name}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-label">Circle:</div>
                        <div className="info-value">{ownerFields?.circle}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-label">Regional Office:</div>
                        <div className="info-value">{ownerFields?.regional}</div>
                    </div>
                    <div className="info-row">
                        <div className="info-label">Branch Info:</div>
                        <div className="info-value">{ownerFields?.branch_info}</div>
                    </div>
                </div>
                <div className="applicant-image">
                    <img
                        src={
                          ownerFields?.pro_pic
                            ? ownerFields?.pro_pic
                            : profileIcon
                        }
                        alt="Applicant Profile"
                      />
                </div>
            </div>
        </div>

        <div className="report-section">
            <div className="report-section-header">ANIMAL DETAILS</div>
            <div className="report-section-content animal-details-content">
                <div className="animal-top-row">
                    <div className="animal-info">
                        <div className="info-row">
                            <div className="info-label">Animal Name:</div>
                            <div className="info-value">{fields.animal_details?.breed?.category_name}</div>
                        </div>
                        <div className="info-row">
                            <div className="info-label">Tag Type:</div>
                            <div className="info-value">{fields.animal_details?.tag_type}</div>
                        </div>
                        <div className="info-row">
                            <div className="info-label">Tag Number:</div>
                            <div className="info-value">{fields.animal_details?.tag_no}</div>
                        </div>
                        <div className="info-row">
                            <div className="info-label">Animal Type:</div>
                            <div className="info-value">{fields.animal_details?.type?.display_name}</div>
                        </div>
                        <div className="info-row">
                            <div className="info-label">Breed:</div>
                            <div className="info-value">{fields.animal_details?.breed?.name}</div>
                        </div>
                        <div className="info-row">
                            <div className="info-label">Age:</div>
                            <div className="info-value">{fields.animal_details?.details?.current_display_age}</div>
                        </div>
                        {/*<div className="info-row">
                            <div className="info-label">Weight:</div>
                            <div className="info-value">{fields.animal_details?.details?.weight} kgs</div>
                        </div>*/}
                        {
                            fields.animal_details?.type?.display_name.includes("Already Calved") ?
                            <div className="info-row">
                                <div className="info-label">Milk:</div>
                                <div className="info-value">{fields.animal_details?.details?.milking_quantity} ltr</div>
                            </div>
                            :
                            <div className="info-row">
                                <div className="info-label">Expected Milk:</div>
                                <div className="info-value">{fields.animal_details?.details?.milking_quantity} ltr</div>
                            </div>
                        }
                        {
                            fields.animal_details?.type?.display_name.includes("Already Calved") ?
                            <div className="info-row">
                                <div className="info-label">Calvings:</div>
                                <div className="info-value">{fields.animal_details?.details?.no_of_calvings}</div>
                            </div>
                            :
                            <div className="info-row">
                                <div className="info-label">Pregnancy:</div>
                                {
                                    fields.animal_details?.details?.pregnancy_selector === 'No' ?
                                    <div className="info-value">{fields.animal_details?.details?.pregnancy_selector}</div>
                                    :
                                    <div className="info-value">{fields.animal_details?.details?.pregnancy_selector} - {fields.animal_details?.details?.pregnancy_period}</div>
                                }
                            </div>
                        }
                        {
                            fields.animal_details?.details?.latitude && fields.animal_details?.details?.latitude !== '' ?
                            <div className="info-row no-wrap">
                                <div className="info-label">Geo location:</div>
                                <div className="info-value">{fields.animal_details?.details?.latitude}, {fields.animal_details?.details?.longitude}</div>
                            </div> : null
                        }
                    </div>
                    <div className="animal-info">
                        <div className="info-row">
                            <div className="info-label">Animla ID:</div>
                            <div className="info-value">{animalid}</div>
                        </div>
                    </div>
                </div>
                <div className="animal-images-bottom">
                    {
                        fields.animal_details?.images_keys?.map((e, key) => {
                            if(fields.animal_details?.images?.[e] !== '' && fields.animal_details?.images?.[e] !== 'https://dev-animal-images.anitra.co.in/'){
                                return <div className="animal-image animal-image-bottom" key={key}>
                                    <img
                                        src={fields.animal_details?.images?.[e]}
                                        alt={`Animal ${key + 1}`}
                                    />
                                </div>
                            }
                        })
                    }
                    {
                        fields.animal_details?.muzzle_video && fields.animal_details?.muzzle_video !== '' ?
                        <div className="animal-image animal-image-bottom">
                            <video
                                width="300"
                                height="300"
                                controls
                                preload="metadata"
                                className="animal-video"
                              >
                                <source
                                  src={fields.animal_details?.muzzle_video}
                                  type="video/mp4"
                                />
                                Your browser does not support the video tag.
                            </video>
                        </div> : null
                    }
                </div>
            </div>
        </div>
    </div>
  );
};

export default AnimalDetails;